/**
 * Nom de la marque, écrit une seule fois. C'est un nom propre, identique dans les six langues : il
 * n'a pas sa place dans les fichiers de traduction, et ne doit pas être recopié en dur dans les
 * écrans (le test `noHardcodedFrench` y voit du français à cause du « é »).
 */
export const NOM_MARQUE = 'Horméia';
